import { getReadingPositionStorage } from './storage';
import type { IReadingPosition } from '@legere/storage-manager';

export class ReadingPositionTracker {
  private bookId: string;
  private storage = getReadingPositionStorage();
  private scrollHandler: (() => void) | null = null;

  constructor(bookId: string) {
    this.bookId = bookId;
  }

  async savePosition(scrollTop: number, scrollHeight: number): Promise<void> {
    const scrollPercentage = (scrollTop / scrollHeight) * 100;

    const position: IReadingPosition = {
      bookId: this.bookId,
      scrollPosition: scrollTop,
      scrollPercentage,
      timestamp: new Date(),
    };

    await this.storage.savePosition(position);
  }

  async restorePosition(): Promise<number | null> {
    const position = await this.storage.getPosition(this.bookId);
    return position?.scrollPercentage ?? null;
  }

  startTracking(container: HTMLElement): void {
    this.scrollHandler = () => {
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight - container.clientHeight;

      if (scrollHeight > 0) {
        this.savePosition(scrollTop, scrollHeight);
      }
    };

    container.addEventListener('scroll', this.scrollHandler);
  }

  stopTracking(container: HTMLElement): void {
    if (this.scrollHandler) {
      container.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }
  }

  async clearPosition(): Promise<void> {
    await this.storage.deletePosition(this.bookId);
  }
}
